import styled from "styled-components";

//MISC
import { COLORS, SIZE, BORDER_RADIUS } from "constants/variables";
import cursorIcon from "assets/img/Cursor.png";

export const CardWrapper = styled.div<{ href?: string }>`
  background-color: ${COLORS.Cultured};
  border-radius: ${BORDER_RADIUS.radius24};
  width: 100%;
  padding: ${SIZE.max24};
  height: auto;
  cursor: ${({ href }) => (href ? "pointer" : "default")};
`;

export const PdfWrapper = styled.a<{ biggerCursor?: boolean }>`
  cursor: ${({ biggerCursor }) =>
    biggerCursor ? `url(${cursorIcon}), auto` : `pointer`};
  color: ${COLORS.VividAuburn};
`;
